import dynamic from 'next/dynamic';
import { MessageProps } from './SuccessMessage.types';

export const SuccessMessage = dynamic<MessageProps>(() =>
  import('./SuccessMessage').then(module => module.SuccessMessage)
);
